export default function(a, e, sinphi) {
  var temp = e * sinphi;
  return a / Math.sqrt(1 - temp * temp);
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/proj4/lib/common/gN.js
// module id = 41
// module chunks = 0